/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListOperations200ResponseItemsInner } from './ListOperations200ResponseItemsInner';
import {
    ListOperations200ResponseItemsInnerFromJSON,
    ListOperations200ResponseItemsInnerFromJSONTyped,
    ListOperations200ResponseItemsInnerToJSON,
    ListOperations200ResponseItemsInnerToJSONTyped,
} from './ListOperations200ResponseItemsInner';

/**
 * 支払業務一覧
 * @export
 * @interface ListOperations200Response
 */
export interface ListOperations200Response {
    /**
     * 
     * @type {Array<ListOperations200ResponseItemsInner>}
     * @memberof ListOperations200Response
     */
    items: Array<ListOperations200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListOperations200Response
     */
    paging: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListOperations200Response interface.
 */
export function instanceOfListOperations200Response(value: object): value is ListOperations200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('paging' in value) || value['paging'] === undefined) return false;
    return true;
}

export function ListOperations200ResponseFromJSON(json: any): ListOperations200Response {
    return ListOperations200ResponseFromJSONTyped(json, false);
}

export function ListOperations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOperations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListOperations200ResponseItemsInnerFromJSON)),
        'paging': ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListOperations200ResponseToJSON(json: any): ListOperations200Response {
    return ListOperations200ResponseToJSONTyped(json, false);
}

export function ListOperations200ResponseToJSONTyped(value?: ListOperations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ListOperations200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

